import React from 'react';

import {convertLocationParamsFoldersDocumentsToFetchParams} from 'app/documents/api';
import {useFolders} from 'app/folders/api';
import {useAddFoldersToTeam} from 'app/teams/api';
import {AddNewTeamDocButton} from 'app/teams/components/TeamDetailPage/components/AddNewTeamDocButton';

import type {DashboardFoldersFetchParamsType} from 'app/documents/types';
import type {OverlayPlacementType} from 'app/general/overlays';
import type {FolderSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  buttonClass?: string;
  placement?: OverlayPlacementType;
};

export const AddNewTeamFolderButton = ({
  team,
  buttonClass,
  placement,
}: Props) => {
  const [addFoldersToTeam] = useAddFoldersToTeam();

  return (
    <AddNewTeamDocButton<FolderSerializedType, DashboardFoldersFetchParamsType>
      team={team}
      buttonClass={buttonClass}
      placement={placement}
      contentType="folder"
      addAction={addFoldersToTeam}
      useDataHook={useFolders}
      pageParam={'folders_page'}
      paramsConverter={convertLocationParamsFoldersDocumentsToFetchParams}
    />
  );
};
